/* eslint-disable */
import React from 'react';
import { connect } from 'react-redux';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { revisionFetchIsLoading, revisionFetchHasErrored, revision } from '../actions/actionCreator';
import { callGopher } from '../assets/js/gopher.js';
import { formatXml, getSitecontentHTML } from '../assets/js/helper';

const mapStateToProps = (state) => {
  let latestRevision = 0;
  if (state.revision.length) latestRevision = state.revision[0].id;
  return { latestRevision };
};

const mapDispatchToProps = (dispatch) => ({
  revisionFetchIsLoading: (isLoading) => dispatch(revisionFetchIsLoading(isLoading)),
  revisionFetchHasErrored: (hasErrored) => dispatch(revisionFetchHasErrored(hasErrored)),
  revision: (revisionLoaded) => dispatch(revision(revisionLoaded)),
});

const revertTooltip = (
  <Tooltip id="revertTooltip"><strong>Revert to this version of the file</strong></Tooltip>
);

const copyTooltip = (
  <Tooltip id="copyTooltip"><strong>Copy to clipboard</strong></Tooltip>
);

class XmlView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      copied: false,
      restoreStatus: 'Processing...',
      disableRevert: false,
      revertButtonText: 'Restore Revision',
    };
  }

  doRestore(restoreRev, restoreFolder, restoreFile, restoreId) {
    document.getElementById('fileRevision').scrollTop = 0;
    this.setState({ disableRevert: true, revertButtonText: 'Restoring Revision...' });

    const gopherDataJson = {
      script_name: 'dvsweb-revert-file',
      script_params: {
        revision_number: restoreRev,
        file_to_revert: restoreFolder + '/' + restoreFile + '.xml',
        site_ids: [restoreId],
        dvs_message: 'Restoring Revision: ' + restoreRev + ' {gopher}',
      },
    };
    const gopherThen = (json) => {
      document.getElementById('fileRevision').scrollTop = 0;
      this.props.callDVS(
        this.props.revisionFetchIsLoading,
        this.props.revisionFetchHasErrored,
        this.props.revision,
        'REVISION',
        this.props.resId,
        this.props.resFolder,
        this.props.resFile,
      );
      this.setState({ revertButtonText: 'Restored Revision', restoreStatus: json.status });
    };
    const gopherFail = (e) => {
      console.log('POST TO GOPHER FAILED: ' + e + ' ');
      this.setState({
        revertButtonText: 'Restore Revision',
        disableRevert: false,
        restoreStatus: `${e}. Try again.`,
      });
    };

    callGopher(gopherDataJson, gopherThen, gopherFail);
  }

  render() {
    return (
      <div className="display-container">
        {this.props.latestRevision !== this.props.resNumber && (
          <div className="restore-btn">
            <OverlayTrigger placement="top" overlay={revertTooltip}>
              <Button
                disabled={this.state.disableRevert}
                onClick={() => this.doRestore(this.props.resNumber, this.props.resFolder, this.props.resFile, this.props.resId)}
                variant="primary"
              >
                <div className="cleanFocus">{this.state.revertButtonText}</div>
              </Button>
            </OverlayTrigger>
          </div>
        )}
        <div className="copy-btn">
          <OverlayTrigger placement="top" overlay={copyTooltip}>
            <CopyToClipboard text={this.props.xml} onCopy={() => this.setState({ copied: true })}>
              <Button variant="primary">Copy</Button>
            </CopyToClipboard>
          </OverlayTrigger>
        </div>
        {this.props.resFolder === 'sitecontent' && this.props.xml && this.props.xml !== '' ? (
          <div className="xml-html-display" dangerouslySetInnerHTML={{ __html: getSitecontentHTML(this.props.xml) }} />
        ) : (
          <pre className="xml-html-display" dangerouslySetInnerHTML={{ __html: formatXml(this.props.xml) }} />
        )}
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(XmlView);
